module.exports = __webpack_public_path__ + "img/04-326x184-keady.aefe1473.jpg";